import award from './images/award.svg'
import beeHive from './images/bee-hive.svg'
import books from './images/books.svg'
import briefcase from './images/briefcase.png'
import coffee from './images/coffee.svg'
import communication from './images/communication.png'
import designClub from './images/design-club.svg'
import flowerVase from './images/flower-vase.svg'
import gift from './images/gift.svg'
import handshake from './images/handshake.png'
import homeOffice from './images/home-office.png'
import house from './images/house.svg'
import jediBlobert from './images/jedi-blobert.svg'
import lampNoBg from './images/lamp-no-bg.svg'
import lamp from './images/lamp.png'
import magicWand from './images/magic-wand.svg'
import newspaper from './images/newspaper.svg'
import paintPalette from './images/paint-palette.svg'
import painting from './images/painting.svg'
import people from './images/people.png'
import pets from './images/pets.svg'
import piggybank from './images/piggybank.png'
import smallBiz from './images/small-biz.svg'
import spaghetti from './images/spaghetti.svg'
import spark from './images/spark.png'
import spk from './images/spk.svg'
import spoak from './images/spoak.svg'
import spoakVase from './images/spoakVase.png'
import thinker from './images/thinker.png'
import trophy from './images/trophy.svg'
import trumpet from './images/trumpet.svg'
import viz from './images/viz.svg'
import wine from './images/wine.svg'

export default {
  award,
  beeHive,
  books,
  briefcase,
  coffee,
  communication,
  designClub,
  flowerVase,
  gift,
  handshake,
  homeOffice,
  house,
  jediBlobert,
  lampNoBg,
  lamp,
  magicWand,
  newspaper,
  paintPalette,
  painting,
  people,
  pets,
  piggybank,
  smallBiz,
  spaghetti,
  spark,
  spk,
  spoak,
  spoakVase,
  thinker,
  trophy,
  trumpet,
  viz,
  wine,
}
